import { BookOpen, CheckCircle2, Code2, Globe, GraduationCap, PencilLine, Wrench, type LucideIcon } from 'lucide-react';

const icons = new Map<string, LucideIcon>([
  ['book-open', BookOpen], ['code', Code2], ['proof', CheckCircle2],
  ['📘', BookOpen], ['📗', BookOpen], ['📙', BookOpen], ['📕', BookOpen],
  ['📚', BookOpen], ['📝', PencilLine], ['🔧', Wrench],
  ['🎓', GraduationCap], ['🌍', Globe],
]);
const symbols = new Map([['turnstile', '⊢'], ['conjunction', '∧'], ['forall', '∀']]);

/** Named catalogue icons, with support for existing custom emoji metadata. */
export function WorldIcon({ name, size = 28 }: { name?: string; size?: number }) {
  const iconName = name?.trim() || 'book-open';
  const Icon = icons.get(iconName);
  if (Icon) return <Icon size={size} aria-hidden="true" className="shrink-0" />;
  const symbol = symbols.get(iconName);
  return <span aria-hidden="true" className={`inline-flex shrink-0 items-center justify-center leading-none ${symbol ? 'font-serif' : ''}`} style={{ width: size, height: size, fontSize: symbol ? size * 1.15 : size }}>{symbol ?? iconName}</span>;
}
